import { queryClient } from "@/app/query";

function invalidatePrefix(prefix: string) {
    void queryClient.invalidateQueries({
        predicate: (query) =>
            typeof query.queryKey[0] === "string" && query.queryKey[0].startsWith(prefix),
    });
}

/**
 * A notification was raised, collapsed, read or dismissed — the `notification` SSE topic,
 * and every mutation on this feature.
 *
 * One prefix covers the inbox list, a single row and the counts, which is what we want:
 * the three move together by construction. A repeat of a live condition bumps `count` on a
 * row already on screen AND re-marks it unread, so refetching the list without the badge
 * would leave the bell showing a number that is one behind — the exact "this one thing
 * doesn't update" failure that has no error attached to it.
 */
export function invalidateNotifications() {
    invalidatePrefix("/api/v1/notifications");
}
